import React from 'react';
import PropTypes from 'prop-types';
import 'Components/TopSellers/TopSellersSkeletonCard.scss';

export default function TopSellersSkeletonCard({ number }) {
  return (
    <div className="ts-item fake-ts-item">
      <div className="ts-item-wrapper">
        <div className="ts-number align-self-center">
          { number }
        </div>
        <div className="ts-img-wrapper align-self-center">
          <div className="responsive-image-island">
            <div className="responsive-image responsive-image--16by9">
              <div />
            </div>
          </div>
        </div>
        <div className="ts-body">
          <div className="fake-product-name" />
          <div className="fake-product-icons" />
        </div>
        <div className="ts-pricing">
          <div className="top-seller-meta top-seller-meta-pricing">
            <div className="card-price-container">
              <div className="fake-price" />
            </div>
          </div>
          <div className="hit-card-buttons-container">
            <div className="btn fake-btn" />
            <div className="btn fake-btn" />
          </div>
        </div>
      </div>
    </div>
  );
}

TopSellersSkeletonCard.propTypes = {
  number: PropTypes.number.isRequired,
};
